<template>
  <div>
    <a-drawer :title="`${sourceId ? '编辑' : '添加'}${isStory ? '故事' : '需求'}`" :width="960" destroy-on-close :visible="visible" :body-style="{ paddingBottom: '80px' }" :mask-closable="false" @close="close('cancel')">
      <a-form-model ref="form" :rules="rules" :model="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="标题" prop="title">
              <a-input v-model="form.title" placeholder="请填写标题" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="需求类型" prop="requirement_type" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.requirement_type" :disabled="isStory">
                <a-select-option v-for="(item, key) in storyTypes" :key="key" :value="item.value">
                  <a-badge :color="item.color" :text="item.label" />
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="优先级" prop="priority" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.priority" placeholder="优先级" style="width: 100%" allow-clear @change="handleChange">
                <a-select-option v-for="item in ['P0', 'P1', 'P2', 'P3']" :key="item" :value="item"> {{ item }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item :disabled="['ticket', 'business_requirement'].includes(sourceType)" label="所属项目" prop="project_id">
              <a-select v-model="form.project_id" placeholder="所属项目">
                <a-select-option v-for="item in projects" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="父需求" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-tree-select v-model="parentRequirement" :disabled="form.project_id === null" label-in-value show-search :replace-fields="replaceFields" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择父需求" :tree-data="requirementData" :tree-expanded-keys.sync="expendedKeys" :search-value.sync="searchValue" allow-clear dropdown-match-select-width @change="onChange" @select="onSelect" @search="getStoryTree" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="负责人" prop="handlers" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <user-select v-model="form.handlers" mode="multiple" show-search placeholder="负责人" :project-id="projectId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="技术负责人" prop="tech_owner" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <user-select v-model="form.tech_owner" mode="multiple" show-search placeholder="技术负责人" :project-id="projectId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="参与团队" prop="teams" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.teams" mode="multiple" show-search :filter-option="utils.filterOption">
                <a-select-option v-for="(team, index) in teams" :key="index" :value="team.id">{{ team.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="开始时间" prop="start_time" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-date-picker v-model="form.start_time" :disabled-date="disabledStartDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择开始时间" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="结束时间" prop="end_time" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-date-picker v-model="form.end_time" :disabled-date="disabledEndDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择结束时间" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="需求评审时间" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-date-picker v-model="form.is_review" :disabled-date="disabledStartDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择开始时间" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="技术评审时间" prop="technical_review" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-date-picker v-model="form.technical_review" :disabled-date="disabledStartDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择开始时间" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="产品" prop="pm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <user-select v-model="form.pm" mode="multiple" show-search placeholder="产品" :project-id="projectId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="运营" prop="operators" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <user-select v-model="form.operators" mode="multiple" show-search placeholder="运营" :project-id="projectId" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="质量" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <user-select v-model="form.qa" mode="multiple" show-search placeholder="质量" :project-id="projectId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="ui设计" prop="designer" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <user-select v-model="form.designer" mode="multiple" show-search placeholder="ui设计" :project-id="projectId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="故事点" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-input-number v-model="form.point" style="width: 100%" :max="100" />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item label="是否拆分完成" prop="split_done" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-radio-group v-model="form.split_done" :default-value="form.split_done">
                <a-radio :value="1"> 完成</a-radio>
                <a-radio :value="0"> 未完成 </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="文档链接" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-input-number v-model="form.point" style="width: 100%" :max="100" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="业务需求2">
              <business-requirement-select v-model="form.business_requirements" :disabled="requirementSelectDisabled" :label-in-value="true" mode="multiple" :status="[135, 136, 137]" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="需求标签" prop="tag">
              <div style="position: relative">
                <a-select v-model="form.tag" mode="multiple" :max-tag-count="5" placeholder="请选择需求标签" disabled>
                  <a-select-option v-for="(item, index) in tagData" :key="index" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="描述" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <am-editor ref="AmEditor" :content="form.description" :drag="true" height="300px" :tool-bar="toolBar" @change="descChange" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="drawer-bottom-menu" style="z-index: 10001">
        <a-button :style="{ marginRight: '8px' }" @click="close('cancel')"> 取消 </a-button>
        <a-button v-if="sourceId === null" :loading="loading" :style="{ marginRight: '8px' }" @click="onSubmit('next')"> 完成并创建下一个 </a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit('ok')"> 完成 </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { tagList } from '@/api/system/tag';
import { getCookies, hasUploadingImages } from '@/utils/utils';
import { teamList } from '@/api/system/team';
import { projectList, projectInvolvedList } from '@/api/project/project';
import { storyStatus, storyTypes, storyPrioritys } from '@/utils/dictionary';
import { storyUpdate, storyAdd, storyTree, storyDetail } from '@/api/project/story';

import moment from 'moment';
import AmEditor from '@/components/AmEditor/index';
import UserSelect from '@/components/User/UserSelect';
import BusinessRequirementSelect from '@/pages/business/document/components/BusinessRequirementSelect';

const toolBar = [
  [
    {
      type: 'collapse',
      groups: [
        {
          items: ['image-uploader', 'codeblock', 'table', 'file-uploader', 'video-uploader', 'math', 'status']
        }
      ]
    }
  ],
  ['heading', 'fontfamily', 'fontsize'],
  ['bold', 'italic', 'strikethrough', 'underline'],
  ['fontcolor', 'backcolor'],
  ['alignment'],
  ['unorderedlist', 'orderedlist', 'tasklist', 'indent']
];

export default {
  components: { AmEditor, UserSelect, BusinessRequirementSelect },
  props: {
    isStory: {
      type: Boolean,
      default: false
    },
    versionId: {
      type: [Number, String],
      default: null
    },
    sourceType: {
      type: [Array, Number, String],
      default: null
    },
    parent: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      storyStatus,
      storyTypes,
      storyPrioritys,
      toolBar,
      teams: [],
      projects: [],
      tagData: [],
      visible: false,
      loading: false,
      uploading: false,
      sourceId: null,
      dataSource: {},
      actionUrl: `${process.env.VUE_APP_DADA_URL}/v1/basic/resourceUpload`,
      headers: {
        Authorization: getCookies()
      },
      data: {
        resource_type: 2
      },
      fileList: [],
      searchValue: '',
      requirementData: [],
      parentRequirement: { key: null },
      expendedKeys: [],
      form: {
        parent_id: null,
        attach: null,
        description: null,
        start_time: null,
        project_id: null,
        end_time: null,
        pm: [],
        qa: [],
        designer: [],
        operators: [],
        business_requirements: []
      },
      description: null,
      requirementSelectDisabled: false,
      projectId: parseInt(this.$route.params.project_id) || 0,
      replaceFields: { key: 'id', value: 'id' },
      rules: {
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        project_id: [{ required: true, message: '所属项目不能为空', trigger: 'blur' }],
        is_review: [{ required: true, message: '需求评审时间不能为空', trigger: 'change' }],
        status: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
        requirement_type: [{ required: true, message: '需求类型不能为空', trigger: 'blur' }]
        // description: [{ required: true, message: '描述内容不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    // 计算开始时间禁用范围
    disabledStartDate() {
      return startValue => {
        const endValue = moment(this.form.end_time || null);
        if (!startValue || !endValue) {
          return false;
        }
        return startValue.valueOf() > endValue.valueOf();
      };
    },

    // 计算结束时间禁用范围
    disabledEndDate() {
      return endValue => {
        const startValue = moment(this.form.start_time || null);
        if (!endValue || !startValue) {
          return false;
        }
        return startValue.valueOf() > endValue.valueOf();
      };
    }
  },
  watch: {
    parent() {
      this.parentRequirement = this.parent;
      this.form.parent_id = this.parentRequirement.key;
      if (this.parent && this.form.parent_id) {
        this.getStoryDetail(this.parentRequirement.key);
      }
    },
    'form.project_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal) {
          this.getStoryTree();
        }
        if (oldVal) {
          this.form.parent_id = null;
          this.parentRequirement = {};
        }
      }
    }
  },
  methods: {
    /**
     * 打开抽屉事件
     * @param {*} sourceId
     * @param {*} dataSource
     */
    onOpen(sourceId, dataSource) {
      this.visible = true;
      this.sourceId = sourceId;
      this.dataSource = dataSource;
      // 在业务需求页面创建产研需求时，如果业务需求不为空，则业务需求下拉选择框置为禁用状态
      if (sourceId === null && dataSource.business_requirements.length > 0) {
        this.requirementSelectDisabled = true;
      }
      this.getTagList();
      this.getTeamList();
      this.getProjectList();
      if (this.sourceId) {
        this.parentRequirement = { key: this.dataSource.parent_id, label: this.dataSource.parent_title };
        this.form = {
          id: this.dataSource.id,
          title: this.dataSource.title,
          start_time: this.dataSource.start_time || null,
          end_time: this.dataSource.end_time || null,
          requirement_type: this.dataSource.requirement_type,
          status: this.dataSource.status,
          description: this.dataSource.description || '',
          comment: this.dataSource.comment,
          priority: this.dataSource.priority,
          project_id: this.dataSource.project_id || this.projectId,
          is_review: this.dataSource.is_review,
          technical_review: this.dataSource.technical_review,
          pm: this.getUsers(this.dataSource.pm),
          teams: this.dataSource.teams,
          qa: this.getUsers(this.dataSource.qa),
          designer: this.getUsers(this.dataSource.designer),
          handlers: this.getUsers(this.dataSource.handlers),
          operators: this.getUsers(this.dataSource.operators),
          parent_id: this.dataSource.parent_id,
          point: this.dataSource.point,
          tech_owner: this.getUsers(this.dataSource.tech_owner),
          split_done: this.dataSource.split_done || 0,
          tag: this.dataSource.tags.map(item => {
            return item.id;
          }),
          business_requirements: this.dataSource.business_requirements.map(item => {
            return { label: `BR-${item}`, key: item };
          })
        };
      } else {
        this.form = {
          ...this.form,
          description: this.description,
          project_id: this.projectId,
          start_time: null,
          end_time: null,
          business_requirements: [],
          requirement_type: this.isStory ? 4 : null
        };
        if (Array.isArray(dataSource.business_requirements)) {
          this.form.business_requirements = dataSource.business_requirements.map(item => {
            return { label: `BR-${item.title}`, key: item.id };
          });
        }
      }
    },

    /**
     * 关闭抽屉事件
     */
    close() {
      this.fileList = [];
      this.loading = false;
      this.visible = false;
      this.$refs.form.resetFields();
      this.$emit('cancel');
    },

    /**
     * 获取团队列表
     */
    getTeamList() {
      teamList({}).then(res => {
        this.teams = res.data.items;
      });
    },

    /**
     * 获取用户列表
     */
    getUsers(users) {
      return users ? users.map(item => item.id) : [];
    },

    /**
     * 获取标签列表
     */
    getTagList() {
      tagList({ group_code: 'task_req_tag' }).then(res => {
        this.tagData = res.data.items;
      });
    },

    /**
     * 需求描述变更时间回调
     * @param {*} content
     */
    descChange(content) {
      this.form.description = content;
    },

    /**
     * 需求筛选
     * @param {*} searchValue
     * @param {*} treeNode
     */
    fillterRequirement(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },

    /**
     * 获取需求树
     */
    getStoryTree() {
      this.requirementData = [];
      this.expendedKeys = [];
      storyTree({ project_id: this.form.project_id, page_index: 1, page_size: 20, title: this.searchValue, skip_story: true }).then(res => {
        this.requirementData = [{ id: 0, title: '根需求' }, ...res.data.items];
        this.expendedKeys = res.data.requirement_ids;
      });
    },

    /**
     * 获取项目列表
     */
    getProjectList() {
      if (this.projectId === null) {
        projectInvolvedList({}).then(res => {
          this.projects = res.data.items;
        });
      } else {
        projectList({}).then(res => {
          this.projects = res.data.projects;
        });
      }
    },

    /**
     * 需求父级变更
     */
    onChange() {
      this.form.parent_id = this.parentRequirement.value;
    },

    /**
     *
     * @param {*} nodeVal
     */
    onSelect(nodeVal) {
      if (this.sourceId === null && nodeVal) {
        this.getStoryDetail(nodeVal.value);
      }
    },

    /**
     * 获取需求详情
     * @param {*} storyId
     */
    getStoryDetail(storyId) {
      if (storyId !== 0) {
        storyDetail({ requirement_id: storyId, project_id: this.form.project_id }).then(res => {
          this.form.pm = res.data.item.pm.map(p => p.id);
          this.form.operators = res.data.item.operators.map(p => p.id);
        });
      }
    },

    handleChange({ fileList }) {
      var attach = [];
      if (fileList instanceof Array) {
        this.fileList = fileList;
        this.uploading = false;
        this.fileList.forEach(item => {
          if (item.status === 'uploading') {
            this.uploading = true;
          }
          if (item.response && item.response.code === 2000) {
            attach.push(item.response.data);
          }
        });
        this.form.attach = JSON.stringify(attach);
      }
    },

    /**
     * 提交需求信息
     * @param {*} type
     */
    onSubmit(type) {
      if (hasUploadingImages(this.form.description)) {
        this.$message.warning('有图片正在上传中，请等待上传完成或去除上传中的图片再提交哦~');
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.sourceId) {
            // 更新需求信息
            storyUpdate({
              ...this.form,
              requirement_id: this.sourceId,
              business_requirements: this.form.business_requirements.map(item => item.key)
            })
              .then(() => {
                this.$message.success('需求修改成功');
                this.close();
                this.$emit('ok');
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            // 添加新需求
            storyAdd({
              ...this.form,
              version_id: this.versionId,
              business_requirements: this.form.business_requirements.map(item => item.key)
            })
              .then(res => {
                this.$message.success('需求添加成功');
                if (this.sourceType === 'ticket') {
                  this.$emit('callback', res.data.id, 'requirement');
                }
                if (type === 'next') {
                  const parent_id = this.form.parent_id;
                  const project_id = this.form.project_id;
                  this.form = {
                    attach: null,
                    description: '',
                    parent_id: parent_id,
                    project_id: project_id,
                    version_id: this.versionId,
                    business_requirements: []
                  };
                  this.loading = false;
                } else {
                  this.close();
                  this.$emit('ok');
                }
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.drawer-bottom-menu {
  position: absolute;
  width: 100%;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

/deep/.ant-form-item {
  margin-bottom: 16px;
}
</style>
